import {
    DEALERBLOCKDSRMASTER_FAILED,
    DEALERBLOCKDSRMASTER_SUCCESS,
    RESET_DEALERBLOCKDSRMASTER,
    LOADING_DEALERBLOCKDSRMASTER,
    NETWORK_ERROR_DEALERBLOCKDSRMASTER
} from '../types/index'

import { dealerServices } from "../../config/axios";
const resetDealerBlockDsrMaster = () => {
    return { type: RESET_DEALERBLOCKDSRMASTER };
};


const dealerBlockDsrMaster = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERBLOCKDSRMASTER });
    await dealerServices
        .post("blockDsrMaster", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerBlockDsrMastersuccess(res.data));
                    break;
                default:
                    dispatch(dealerBlockDsrMasterFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERBLOCKDSRMASTER,
                payload: err
            });
        });
}
function dealerBlockDsrMastersuccess(data) {
    return {
        type: DEALERBLOCKDSRMASTER_SUCCESS,
        payload: data
    };
}
function dealerBlockDsrMasterFailed(data) {
    return {
        type: DEALERBLOCKDSRMASTER_FAILED,
        payload: data
    };
}



export { resetDealerBlockDsrMaster, dealerBlockDsrMaster }